// extracted by mini-css-extract-plugin
export default {"component":"component--m2LEX","dark":"dark--gxthh"};